/*-------------------------- arguments generator types ---------------------------------*/
export const NORMAL = 0;
export const INNER = 1;
export const GENE_ONLY = 2;
export const NO_BATCH = 4;
